// Function to strip HTML tags from message or description
export const stripHtmlTags = (html?: string | null): string => {
  if (!html || typeof html !== "string") return "";
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return (tempDiv.textContent || tempDiv.innerText || "").trim();
};
